<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > <a routerLink="/pdv-lista">{{ 'Lista de PDVs' | translate}}</a> > {{
        pathSelected }}
    </div>
</div>

<main class="container">

    <div class="add_group" [formGroup]="formPdv">
        <h1 i18n>{{ (isCreateMode ? 'Adicionar PDV' : 'PDV: ') | translate}} {{ !isCreateMode ? pathSelected : '' }}</h1>

        <div class="flex form filtros">
            <div class="form-group filtro">
                <label for="pais" i18n>{{ 'País' | translate }}:</label>
                <select id="pais" formControlName="CountryId" (change)="onCountryChange()">
                    <option value="" i18n>{{ 'Selecione um país' | translate }}</option>
                    <option *ngFor="let pais of jsonPaises" [value]="pais.id">{{ pais.name }}</option>
                </select>
            </div>

            <div class="form-group filtro">
                <label for="regiao" i18n>{{ 'Cidade' | translate }}:</label>
                <select id="regiao" formControlName="RegionId" (change)="onRegionChange()">
                    <option value="" i18n>{{ 'Selecione uma cidade' | translate }}</option>
                    <option *ngFor="let regiao of listaRegiao" [value]="regiao.id">{{ regiao.name }}</option>
                </select>
            </div>

            <div class="form-group filtro">
                <label i18n>{{ 'Código da Farmácia' | translate }}:</label>
                <input type="text" class="form-control" formControlName="CdgFarmac">
            </div>

            <div class="form-group filtro">
                <label i18n>{{ 'Nome do PDV' | translate }}:</label>
                <input type="text" class="form-control" formControlName="Name">
            </div>
        </div>

        <div class="flex form filtros">
            <div class="form-group filtro">
                <label i18n>&nbsp;</label>
                <button class="red_button" (click)="savePdv()" type="button" i18n>
                    {{ (isCreateMode ? 'Adicionar' : 'Salvar') | translate }}
                </button>
            </div>
        </div>
    </div>
</main>
